// src/features/MyGymTV/Thumbnail/Thumbnail.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faImage } from '@fortawesome/free-solid-svg-icons';
import { useThumbnail } from '../../../services/useThumbnail';
import './thumbnail.scss';

/**
 * Thumbnail component - displays a cached thumbnail for content
 * 
 * @param {Object} props
 * @param {number} props.contentId - The content ID to display thumbnail for
 * @param {string} props.aspectRatio - 'portrait' (9:16) or 'landscape' (16:9)
 * @param {function} props.onClick - Click handler for preview
 * @param {string} props.alt - Alt text for the image
 */
const Thumbnail = ({ contentId, aspectRatio = 'landscape', onClick, alt = 'Content thumbnail' }) => {
    const { thumbnailUrl, loading, error } = useThumbnail(contentId);

    const aspectClass = aspectRatio === 'portrait' ? 'thumbnail-portrait' : 'thumbnail-landscape';

    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
        }
    };

    return (
        <div
            className={`thumbnail-container ${aspectClass} ${onClick ? 'clickable' : ''}`}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
        >
            {loading && (
                <div className="thumbnail-loading">
                    <FontAwesomeIcon
icon={faSpinner}
spin
                    />
                </div>
            )}

            {!loading && error && (
                <div className="thumbnail-error">
                    <FontAwesomeIcon icon={faImage} />
                    <span>Failed to load</span>
                </div>
            )}

            {!loading && !error && thumbnailUrl && (
                <img
                    alt={alt}
                    className="thumbnail-image"
                    src={thumbnailUrl}
                />
            )}

            {!loading && !error && !thumbnailUrl && (
                <div className="thumbnail-placeholder">
                    <FontAwesomeIcon icon={faImage} />
                </div>
            )}
        </div>
    );
};

export default Thumbnail;